// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"db4dc607ba8b99ab","3851":"1a61937a86418cec","9878":"29046ad685444e73"}[chunkId] + ".css";
};